export default __webpack_public_path__ + "static/media/Poster2.d4ee6dee.jpg";